import { useState, useEffect } from "react";
export function useLocalStorage(key, initialValue = '') {
    // get item from local storage
    function getItemFromStorage(key, initialValue = '') {
        const encodedValue = localStorage.getItem(key) ?? '';
        if (encodedValue) {
            try {
                return JSON.parse(encodedValue);
            }
            catch (e) {
                // If the value is not JSON, return it without parsing.
                return encodedValue;
            }
        }
        // if initial value is a function, call it
        if (typeof (initialValue) === 'function')
            return initialValue();
        return initialValue;
    }
    // set local storage to state
    const [localStorageValue, setLocalStorageValue] = useState(() => {
        return getItemFromStorage(key, initialValue);
    });
    useEffect(() => {
        // when local storage changes, update in local storage
        localStorage.setItem(key, JSON.stringify(localStorageValue));
    }, [localStorageValue]);
    return [localStorageValue, setLocalStorageValue];
}
